@let _previewType = previewType();

<div class="flex flex-1 flex-col gap-2 min-h-0">
  @switch (_previewType) {
    @case ("soap") {
      <div
        class="flex flex-1 flex-col overflow-auto rounded-md border border-slate-200 bg-slate-50 p-4 min-h-0"
      >
        <div
          class="-mx-4 flex flex-col items-center justify-center gap-0 border-b-2 border-slate-200 bg-blue-50 px-4 pt-2 pb-2"
        >
          <span class="text-md font-medium text-slate-900"
            >Esempio referto</span
          >
          <div class="flex flex-row gap-1">
            <span class="text-base text-slate-400">#2024-001</span>
            <span class="text-base text-slate-400">24/02/2025 10:30</span>
            <span class="text-base text-slate-400">12 kg</span>
          </div>
          <span class="text-base text-slate-600">Dr. Mario Rossi</span>
        </div>

        <div class="grid grid-cols-3 text-xs gap-x-2 gap-y-1 py-2">
          <div class="flex flex-row items-center">
            <span class="text-sm text-slate-600">{{
              "Paziente" | transloco
            }}</span>
            <span class="ml-auto text-sm font-bold text-slate-900">Fido</span>
          </div>
          <div class="flex flex-row items-center">
            <span class="text-sm text-slate-600">{{
              "Specie" | transloco
            }}</span>
            <span class="ml-auto text-sm font-bold text-slate-900">Cane</span>
          </div>
          <div class="flex flex-row items-center">
            <span class="text-sm text-slate-600">{{
              "Razza" | transloco
            }}</span>
            <span class="ml-auto text-sm font-bold text-slate-900"
              >Labrador</span
            >
          </div>
          <div class="flex flex-row items-center">
            <span class="text-sm text-slate-600">{{
              "Data di nascita" | transloco
            }}</span>
            <span class="ml-auto text-sm font-bold text-slate-900"
              >15/03/2018</span
            >
          </div>
          <div class="flex flex-row items-center">
            <span class="text-sm text-slate-600">{{
              "Sesso" | transloco
            }}</span>
            <span class="ml-auto text-sm font-bold text-slate-900"
              >Maschio</span
            >
          </div>
          <div class="flex flex-row items-center">
            <span class="text-sm text-slate-600">{{
              "Microchip" | transloco
            }}</span>
            <span class="ml-auto text-sm font-bold text-slate-900"
              >123456789012345</span
            >
          </div>
          <div class="flex flex-row items-center">
            <span class="text-sm text-slate-600">{{
              "Cliente" | transloco
            }}</span>
            <span class="ml-auto text-sm font-bold text-slate-900"
              >Giuseppe Verdi</span
            >
          </div>
          <div class="flex flex-row items-center">
            <span class="text-sm text-slate-600">{{
              "Telefono" | transloco
            }}</span>
            <span class="ml-auto text-sm font-bold text-slate-900"
              >+39 333 1234567</span
            >
          </div>
          <div class="flex flex-row items-center">
            <span class="text-sm text-slate-600">{{
              "Email" | transloco
            }}</span>
            <span class="ml-auto text-sm font-bold text-slate-900"
              >giuseppe.verdi&#64;example.com</span
            >
          </div>
        </div>

        <snt-report-form-renderer
          [templateConfig]="debouncedTemplateConfig()"
          [temlpateConfigWithValues]="dummyPreviewData().template"
          [dataSource]="dummyPreviewData().dataSource"
          [healthRecord]="undefined"
          [readOnly]="false"
          [noThrottle]="true"
          class="flex-1"
        ></snt-report-form-renderer>
      </div>
    }
    @case ("pdf") {
      @if (pdfLoading()) {
        <div class="flex flex-1 items-center justify-center min-h-0">
          <dx-load-indicator></dx-load-indicator>
        </div>
      } @else if (pdfError()) {
        <div class="flex flex-1 items-center justify-center min-h-0">
          <div class="flex flex-col items-center justify-center gap-4">
            <i class="fa-light fa-print-slash fa-4x"></i>
            <span class="text-slate-900">
              {{ "Anteprima non disponibile" | transloco }}
            </span>
            <dx-button
              type="default"
              [text]="'Aggiorna anteprima' | transloco"
              icon="fa-light fa-arrows-rotate"
              (onClick)="refreshPdf()"
            ></dx-button>
          </div>
        </div>
      } @else {
        <div
          class="relative flex flex-1 flex-col overflow-auto rounded-md border border-slate-200 bg-slate-50 min-h-0"
        >
          <div class="flex flex-1 flex-col rounded-md bg-slate-600 p-0">
            <div
              class="flex flex-col"
              style="max-height: 100%; aspect-ratio: 1 / 1.4142"
            >
              <div class="flex flex-1 flex-col bg-white p-2">
                <div class="flex flex-1">
                  <iframe [src]="pdfBlobUrlSafe()" class="flex-1"></iframe>
                </div>
              </div>
            </div>
          </div>

          @if (pdfOutdated()) {
            <div
              class="absolute inset-0 flex items-center justify-center rounded-md bg-slate-900/50"
            >
              <dx-button
                type="default"
                [text]="'Aggiorna anteprima' | transloco"
                icon="fa-light fa-arrows-rotate"
                (onClick)="refreshPdf()"
              ></dx-button>
            </div>
          }
        </div>
      }
    }
  }
</div>
